export default __webpack_public_path__ + "static/media/gallery_04.dcf26756.jpg";